define(function (require) {
    "use strict";

    var RevisionedModel = require("models/RevisionedModel");
    var ApiResources = require("assets/data/apiResources.json");
    var LEResourceResolver = require("leResourceResolver");
    var ManageDomainsBoxCollection = require("manager-collections/ManageDomainsBoxCollection");
    var ManageDomainsBoxItemModel = require("manager-models/ManageDomainsBoxItemModel");

    var KEYS = {
        ENABLED:      "enabled",
        WHITE_LIST:   "whiteList",
        BLACK_LIST:   "blackList"
    };

    var ManageDomainsModel = {};

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        ManageDomainsModel = RevisionedModel.extend({
            KEYS:KEYS,
            resource: ApiResources.AccountConfig.ManageDomains,
            name: "ManageDomainsModel",
            defaults: {
                enabled: false,
                whiteList: [],
                blackList: []
            },

            validation:{
                "whiteList.0":[
                    {
                        fn: function() {
                            // validate hierarchy the collection
                            var whitelistErrors = this.whitelistCollection.validate();
                            if (!_.isEmpty(whitelistErrors)) {
                                return "LEFramework.errors.generalError.on.page";
                            }
                        }
                    }
                ],
                "blackList.0":[
                    {
                        fn: function() {
                            // validate hierarchy the collection
                            var blacklistErrors = this.blacklistCollection.validate();
                            if (!_.isEmpty(blacklistErrors)) {
                                return "LEFramework.errors.generalError.on.page";
                            }
                        }
                    }
                ]
            },

            initialize: function (options) {
                RevisionedModel.prototype.initialize.call(this, options);
            },

            addInclude : function () {
                this.whitelistCollection.addItem();
            },
            addExclude : function () {
                this.blacklistCollection.addItem();
            },

            url: function(){
                //remove id from resource
                return LEResourceResolver.getUrl.call(this, ApiResources.AccountConfig.ManageDomains);
            },

            parse: function(response, options) {
                //add random id to model for know if it new entry or not
                if(!_.isEmpty(response) && !response.id) {
                    response.id = Math.floor((Math.random() * 100));
                }

                this.whitelistCollection = new ManageDomainsBoxCollection();
                if(!_.isEmpty(response.whiteList)) {
                    _.each(response.whiteList, function(entry) {
                        this.whitelistCollection.addItem({url: entry});
                    }, this);
                }
                this.blacklistCollection = new ManageDomainsBoxCollection();
                if(!_.isEmpty(response.blackList)) {
                    _.each(response.blackList, function(entry) {
                        this.blacklistCollection.addItem({url: entry});
                    }, this);
                }

                //default when no include and exclude should contain one empty exclude
                if (this.whitelistCollection.size() === 0) {
                    this.addInclude();
                }
                if (this.blacklistCollection.size() === 0) {
                    this.addExclude();
                }

                return RevisionedModel.prototype.parse.call(this, response, options);
            },

            setManageDomainsData: function() {
                LEManager.logger.debug("Set all data", "ManageDomainsModel:setManageDomainsData.");

                var whitelistArray = [];
                this.whitelistCollection.each(function (model) {
                    var whitelistURL = model.get(ManageDomainsBoxItemModel.KEYS.URL);
                    if(!_.isEmpty(whitelistURL)) {
                        whitelistArray.push(whitelistURL);
                    }
                }, this);
                this.setWhiteList(whitelistArray);

                var blacklistArray = [];
                this.blacklistCollection.each(function (model) {
                    var blacklistURL = model.get(ManageDomainsBoxItemModel.KEYS.URL);
                    if(!_.isEmpty(blacklistURL)) {
                        blacklistArray.push(blacklistURL);
                    }
                }, this);
                this.setBlackList(blacklistArray);
            },

            setEnabled: function (enabled) {
                return this.set(KEYS.ENABLED, enabled);
            },
            getEnabled: function () {
                return this.get(KEYS.ENABLED);
            },
            setWhiteList: function (collection) {
                return this.set(KEYS.WHITE_LIST, collection);
            },
            getWhiteList: function () {
                return this.get(KEYS.WHITE_LIST);
            },
            setBlackList: function (collection) {
                return this.set(KEYS.BLACK_LIST, collection);
            },
            getBlackList: function () {
                return this.get(KEYS.BLACK_LIST);
            }
        });

    });
    ManageDomainsModel.KEYS = KEYS;
    return ManageDomainsModel;
});
